import "./inverterConfig.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { inverterInformation } from "../../DataFiles/inverterInformation";

const InverterDetail = (props) => {
  const { tableContent, index, inverterInfo, roofDetail } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Electrical Equipment Details"
  );
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const check = quantityInfo.allRoof;
  let noOfMountingStructure = "--";
  let pvModule = 0;
  let mountingStructure = "--";

  if (check && quantityInfo.electricalConfiguration === "All Roof") {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      mountingStructure = "Multiple Structure on multi roof.";
      if (element.structureType === "Single") {
        pvModule += element.pvModule;
      } else {
        pvModule += Object.values(element.multipleStructure).reduce(
          (sum, value) => sum + value.pvModule,
          0
        );
      }
    }
  } else {
    const list = roofDetail.multipleStructure;
    if (roofDetail.structureType === "Single") {
      pvModule = roofDetail.pvModule;
      if (roofDetail.roofType === "Flat Roof") {
        noOfMountingStructure = roofDetail.totalStructure;
      }
      mountingStructure = roofDetail.mountingStructure;
    } else {
      pvModule = Object.values(list).reduce(
        (sum, value) => sum + value.pvModule,
        0
      );
      noOfMountingStructure = list
        .reduce((total, data) => total + parseFloat(data.totalStructure), 0)
        .toFixed(0);
      mountingStructure = "Multi-Structure";
    }
  }

  let inverterBrand = inverterInformation.find(
    (item) =>
      item.brand === inverterInfo.inverterManufacturer &&
      item.phase === inverterInfo.inverterPhase &&
      item.systemType === inverterInfo.systemType
  );
  let inverter =
    inverterInfo.inverterType !== "Select"
      ? inverterBrand.inverterType.find(
          (item) => item.name === inverterInfo.inverterType
        )
      : [];

  const DCBreaker =
    inverterInfo.totalStringMPPT +
    (inverterInfo.noOfInverter - 1) * inverterInfo.actualString;

  let inverterDetail = [
    {
      srno: 1,
      equipment: `${inverterInfo.inverterManufacturer} Inverter`,
      manufacturer: `${inverterInfo.inverterType}`,
      quantity: inverterInfo.noOfInverter,
    },
    {
      srno: 2,
      equipment: `${roofDetail.module}`,
      manufacturer: `${roofDetail.moduleType}`,
      quantity: pvModule,
    },
    {
      srno: 3,
      equipment: `Structure`,
      manufacturer: `${mountingStructure}`,
      quantity: noOfMountingStructure,
    },
    {
      srno: 4,
      equipment: `Power Sensor`,
      manufacturer: `${inverterInfo.powerSensor}`,
      quantity: `${inverterInfo.powerSensor === "No Power Sensor" ? 0 : 1}`,
    },
    {
      srno: 5,
      equipment: `Communication Device`,
      manufacturer: `${inverterInfo.communicationDevice}`,
      quantity: `${
        inverterInfo.communicationDevice === "No Communication Device" ? 0 : 1
      }`,
    },
    {
      srno: 6,
      equipment: `DC Breaker(2 pole)`,
      manufacturer: `DC 1000V/32Amps`,
      quantity: DCBreaker,
    },
    {
      srno: 7,
      equipment: `AC Breaker`,
      manufacturer: `AC 500V/${(1.5 * inverter.acCurrent).toFixed(2)}Amps`,
      quantity: inverterInfo.noOfInverter,
    },
    {
      srno: 8,
      equipment: `Main Disconnector Switch`,
      manufacturer: `AC 500V/${(
        inverterInfo.noOfInverter * inverter.acCurrent
      ).toFixed(2)}Amps`,
      quantity: inverterInfo.noOfInverter,
    },
    {
      srno: 9,
      equipment: `MC4 Connectors`,
      manufacturer: `DC 1500V/100Amps`,
      quantity: `${DCBreaker * 4}`,
    },
    {
      srno: 10,
      equipment: `DC Wire`,
      manufacturer: `DC 1000V/4mm² Single core flexible copper`,
      quantity: `approx`,
    },
    {
      srno: 11,
      equipment: `AC Wires`,
      manufacturer: `--`,
      quantity: `--`,
    },
  ];

  function tableRender(tableData) {
    return (
      <div className="render-function">
        <table className="render-table">
          <thead>
            <tr>
              <td>Sr no.</td>
              <td>Equipments</td>
              <td>Description</td>
              <td>Quantity</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                  <td className="left">{item.srno}</td>
                  <td className="right">{item.equipment}</td>
                  <td className="left2">{item.manufacturer}</td>
                  <td className="left3">{item.quantity}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const title = check
    ? quantityInfo.electricalConfiguration === "All Roof"
      ? `Electrical Equipments Detail (All Roof)`
      : `Electrical Equipments Detail (Roof ${index + 1})`
    : `Electrical Equipments Detail`;

  let value = "";
  if (inverterInfo.inverterType === "Select") {
    if (quantityInfo.electricalConfiguration === "All Roof") {
      value = "*Required all roof configuration";
    } else {
      value = "*Required single roof configuration";
    }
  }

  return (
    <div id="inverter-config" className="inverter-config">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="ic-body">
        <p>
          {title} <span>{value}</span>
        </p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(inverterDetail)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default InverterDetail;
